import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect } from 'react';
import { getIdentityDocumentRequest, getIdentityDocumentView, getPatchOperations, IdentityDocumentSidePage, useStaffServiceClient, } from '@skbkontur/staff-common';
import { EmployeeContext } from '../EditSidePage.context';
import { handleDocumentSaveError } from '../EditSidePage.helpers';
export const FormDocument = ({ isEditPage, setSavingState }) => {
    const client = useStaffServiceClient();
    const { state, dispatch, references, trackEmployeeEdit, employerId, initialEmployee, listType } = useContext(EmployeeContext);
    const activeIdentityDocument = state.identityDocuments.find((el) => el.id === state.activeIdentityDocumentId);
    const loadIdentityDocuments = async (employeeId) => {
        try {
            const getIdentityDocuments = listType === 'employee'
                ? client.getIdentityDocuments.bind(client)
                : client.getClientsIdentityDocuments.bind(client);
            const { items } = await getIdentityDocuments(employerId, employeeId, {});
            const newDocs = items.map(getIdentityDocumentView);
            dispatch({ type: 'changeIdentityDocuments', payload: newDocs });
        }
        catch (error) {
            setSavingState('error');
        }
    };
    useEffect(() => {
        if (initialEmployee?.id) {
            loadIdentityDocuments(initialEmployee.id);
        }
        trackEmployeeEdit('openEmployeeEdit');
        return () => trackEmployeeEdit('closeEmployeeEdit');
    }, []);
    const handleDocClose = () => {
        dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'closed' });
    };
    const handleDocSubmit = async (document) => {
        try {
            if (isEditPage) {
                if (!initialEmployee?.id) {
                    return;
                }
                dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'saving' });
                let id = document.id;
                if (!id) {
                    const createIdentityDocument = listType === 'employee'
                        ? client.createIdentityDocument.bind(client)
                        : client.createClientsIdentityDocument.bind(client);
                    const result = await createIdentityDocument(employerId, initialEmployee.id, getIdentityDocumentRequest(document));
                    id = result.id;
                    trackEmployeeEdit('identityDocumentFormSubmitSuccess', { id, context: 'create' });
                }
                else {
                    const oldDocument = state.identityDocuments.find((old) => old.id === id);
                    const patchIdentityDocument = listType === 'employee'
                        ? client.patchIdentityDocument.bind(client)
                        : client.patchClientsIdentityDocument.bind(client);
                    const oldDocRequest = oldDocument ? getIdentityDocumentRequest(oldDocument) : {};
                    const newDocRequest = getIdentityDocumentRequest(document);
                    const operations = getPatchOperations(oldDocRequest, newDocRequest);
                    if (operations.length > 0) {
                        await patchIdentityDocument(employerId, initialEmployee.id, document.id, operations);
                        trackEmployeeEdit('identityDocumentFormSubmitSuccess', { id, context: 'edit' });
                    }
                }
                await loadIdentityDocuments(initialEmployee.id);
            }
            else {
                const newDocs = [...state.identityDocuments];
                const index = newDocs.findIndex((el) => el.id === document.id);
                if (index === -1) {
                    newDocs.push({ ...document, id: new Date().getTime().toString() });
                }
                else {
                    newDocs[index] = document;
                }
                dispatch({ type: 'changeIdentityDocuments', payload: newDocs });
            }
            dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'closed' });
        }
        catch (error) {
            dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'edit' });
            handleDocumentSaveError();
        }
    };
    const handleDocDelete = async () => {
        try {
            trackEmployeeEdit('identityDocumentFormDelete', { id: state.activeIdentityDocumentId });
            if (isEditPage) {
                if (!initialEmployee?.id || !state.activeIdentityDocumentId) {
                    return;
                }
                dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'deleting' });
                const deleteIdentityDocument = listType === 'employee'
                    ? client.deleteIdentityDocument.bind(client)
                    : client.deleteClientsIdentityDocument.bind(client);
                await deleteIdentityDocument(employerId, initialEmployee.id, state.activeIdentityDocumentId);
                await loadIdentityDocuments(initialEmployee.id);
                dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'closed' });
            }
            else {
                const newDocs = [...state.identityDocuments];
                const activeDocumentIndex = newDocs.findIndex((el) => el.id === state.activeIdentityDocumentId);
                newDocs.splice(activeDocumentIndex, 1);
                dispatch({ type: 'changeIdentityDocuments', payload: newDocs });
                dispatch({ type: 'changeIdentityDocumentEditStatus', payload: 'closed' });
            }
        }
        catch (error) {
            setSavingState('error');
        }
    };
    const trackerPayload = {
        id: state.activeIdentityDocumentId,
        context: state.activeIdentityDocumentId ? 'edit' : 'create',
    };
    const handleTrackSaveButtonClick = () => {
        trackEmployeeEdit('identityDocumentFormSubmit', trackerPayload);
    };
    const handleTrackCancelButtonClick = () => {
        trackEmployeeEdit('identityDocumentFormCancel', trackerPayload);
    };
    const handleTrackModalShow = () => {
        trackEmployeeEdit('identityDocumentFormShowConfirmation', trackerPayload);
    };
    const handleTrackModalConfirm = () => {
        trackEmployeeEdit('identityDocumentFormConfirmSubmit', trackerPayload);
    };
    const handleTrackModalCancel = () => {
        trackEmployeeEdit('identityDocumentFormConfirmCancel', trackerPayload);
    };
    const handleTrackSaveFail = () => {
        trackEmployeeEdit('identityDocumentFormSubmitFail', trackerPayload);
    };
    const handleCloseClick = () => {
        trackEmployeeEdit('identityDocumentFormCloseClick', trackerPayload);
    };
    return (_jsx(IdentityDocumentSidePage, { initialState: activeIdentityDocument, documentReferences: references.identityDocuments, onSubmit: handleDocSubmit, onClose: handleDocClose, onDelete: handleDocDelete, status: state.identityDocumentEditStatus, trackSaveButtonClick: handleTrackSaveButtonClick, trackCancelButtonClick: handleTrackCancelButtonClick, trackModalShow: handleTrackModalShow, trackModalConfirm: handleTrackModalConfirm, trackModalCancel: handleTrackModalCancel, trackSaveFail: handleTrackSaveFail, trackCloseClick: handleCloseClick, driverLicenseCategories: references.driverLicenseCategories }));
};
